import HttpBackend from 'i18next-http-backend';
import { path } from 'ramda';
import fallback from './translations/fallback.js';

export default class I18nOCCOBackend {
  static type = 'backend';

  init(services, backendOptions = {}, i18nextOptions = {}) {
    this.services = services;
    this.options = backendOptions;
    this.i18nextOptions = i18nextOptions;

    this.orgBackend = new HttpBackend();
    this.eventBackend = new HttpBackend();

    this.orgBackend.init(
      services,
      {
        loadPath: `${backendOptions.cdn}/${backendOptions.orgId}/global/${backendOptions.projectName}/{{lng}}/{{ns}}.json`,
      },
      i18nextOptions
    );

    this.eventBackend.init(
      services,
      {
        loadPath: `${backendOptions.cdn}/${backendOptions.orgId}/${backendOptions.eventCode}/${backendOptions.projectName}/{{lng}}/{{ns}}.json`,
      },
      i18nextOptions
    );
  }

  read(language, namespace, callback) {
    const readOnce = (backend) =>
      new Promise((resolve) => {
        backend.read(language, namespace, (err, data) => {
          if (err) {
            console.warn('[MergedBackend] Failed to read from one source:', err);
            resolve({});
          } else {
            resolve(data || {});
          }
        });
      });

    Promise.allSettled([readOnce(this.orgBackend), readOnce(this.eventBackend)])
      .then((results) => results.filter((r) => r.status === 'fulfilled').map((r) => r.value))
      .then(([orgData, eventData]) => {
        const fallbackData = path([this.options.projectName, language, namespace], fallback) || {};
        const merged = { ...fallbackData, ...orgData, ...eventData }; // event overrides org
        callback(null, merged);
      })
      .catch((err) => {
        callback(err, false);
      });
  }
}
